module.exports = __webpack_public_path__ + "static/img/基因检测pannal.af985e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/二级标题Banner/基因检测pannal.jpg
// module id = P9H/
// module chunks = 1